<template>
  <div class="reports-wrapper">
    <div>
      <generate-report />
    </div>

    <div>
      <generated-reports-listing class="generated-report-listing" />
    </div>
  </div>
</template>

<script>
import GenerateReport from './components/GenerateReport.vue';
import GeneratedReportsListing from './components/GeneratedReportsListing.vue';
import { AppActions } from '@/app/app.keys';
export default {
  name: 'Reports',
  components: {
    GenerateReport,
    GeneratedReportsListing
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('reports.title'));
  }
};
</script>
<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';
.reports-wrapper {
  display: flex;
  flex-direction: column;
  background-color: $background-level-2;
}

.reports-header {
  font-weight: bold;
}

.generate-report {
  display: flex;
  flex-direction: column;
  padding: 60px;
  background-color: $background-level-3;
}

.generated-report-listing {
  height: 50%;
}
</style>
